import Component from './Guide.vue';

export default {
  install(Vue) {
    Vue.component('BkfGuide', Component);
  },
};
